<template>
    <notes :reference-id="$route.params.slug" reference-type="proposal" />
</template>

<script>
    import Notes from '../../../components/Notes'
    
    export default {
        components: {Notes}
    }
</script>
